import Vue from 'vue'
import Router from 'vue-router'
import Qvind from '@/view/qvInd'
import qvKanDian from '@/view/qvkandiancom'
import qvKancndian from '@/view/qvkandiancn'
import qvWencn from '@/view/qvWencn'
import qvKancn from '@/view/qvKancn'
import qvKanWencn from '@/view/qvKanWencn'

import Contdetailpage from '@/viewsource/Contdetailpage'
import Contnews from '@/viewsource/Contnews'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    
    {
      path: '/',
      name: 'Qvind',
      component: Qvind
    },
    {
      path: '/qvkdcm',
      name: 'qvKanDian',
      component: qvKanDian
    },
    {
      path: '/qvkdcn',
      name: 'qvKancndian',
      component: qvKancndian
    },
    {
      path: '/qvwcn',
      name: 'qvWencn',
      component: qvWencn
    },
    {
      path: '/qvkcn',
      name: 'qvKancn',
      component: qvKancn
    },
    {
      path: '/qvkwencn',
      name: 'qvKanWencn',
      component: qvKanWencn
    },
    {
      path: '/Contdetailpage',
      name: 'Contdetailpage',
      component: Contdetailpage
    },
    {
      path: '/Contnews',
      name: 'Contnews',
      component: Contnews
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js